var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 38,
    viewBox: "0 0 80 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7678 20.5124C79.7441 19.5361 79.7441 17.9532 78.7678 16.9769L62.8579 1.06696C61.8816 0.0906541 60.2986 0.0906539 59.3223 1.06696C58.346 2.04328 58.346 3.62619 59.3223 4.6025L73.4645 18.7446L59.3223 32.8868C58.346 33.8631 58.346 35.446 59.3223 36.4223C60.2986 37.3986 61.8816 37.3986 62.8579 36.4223L78.7678 20.5124ZM-2.18557e-07 21.2446L77 21.2446L77 16.2446L2.18557e-07 16.2446L-2.18557e-07 21.2446Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.26aa1f26ca8df065c5864da953e11fd5.svg";
export { ForwardRef as ReactComponent };